import Kphan from "../../../images/about/kphan.jpg";
import Df1314 from "../../../images/about/df1314.jpg";
import Ms8364 from "../../../images/about/ms8364.jpg";
import Wh9128 from "../../../images/about/wh9128.jpg";
import Arthurts from "../../../images/about/arthurts.jpg";
import Jt7347 from "../../../images/about/jt7347.jpg";
import Ernestm from "../../../images/about/ernestm.jpg";
import Dd6849 from "../../../images/about/dd6849.jpg";
import Ab0824 from "../../../images/about/ab0824.jpg";
import Ih2422 from "../../../images/about/ih2422.jpg";
import Jt1065 from "../../../images/about/jt1065.jpg";
import Dc4266 from "../../../images/about/dc4266.jpg";
import dsingh from "../../../images/about/dsingh.png";
import Edchen from "../../../images/about/edchen.jpg";
import Fh9696 from "../../../images/about/fh9696.jpg";
import An4978 from "../../../images/about/an4978.jpg";
import Dc2326 from "../../../images/about/dc2326.jpg";
import sg6836 from "../../../images/about/sg6836.jpg";

export const memberData = [
  {
    name: "Ernest McCarter",
    roles: ["Pacbot\nHigh-Level Lead 2023-24\nCommunications Lead 2022-23"],
    years: ["2022 - 2023", "2023 - 2024"],
    gradYear: "Class of 2024",
    major: "Computer Science",
    image: Ernestm,
  },
  {
    name: "Ian Henriques",
    roles: [
      "Pacbot\nHigh-Level Lead 2023-25\nLow-Level Lead 2022-23",
      "Golf Cart\nSoftware Lead 2024-25",
    ],
    years: ["2022 - 2023", "2023 - 2024", "2024 - 2025"],
    gradYear: "Class of 2025",
    major: "Electrical & Computer Engineering",
    image: Ih2422,
  },
  {
    name: "Andy Nguyen",
    roles: ["Pacbot\nSoftware Lead 2024-25"],
    years: ["2024 - 2025"],
    gradYear: "Class of 2025",
    major: "Electrical & Computer Engineering",
    image: An4978,
  },
  {
    name: "Jack Toubes",
    roles: ["Pacbot\nLow-Level Lead 2021-24\nHardware Lead 2024-25"],
    gradYear: "Class of 2025",
    years: ["2021 - 2022", "2022 - 2023", "2023 - 2024", "2024 - 2025"],
    major: "Electrical & Computer Engineering",
    image: Jt1065,
  },
  {
    name: "Dave Singh",
    roles: ["Pacbot\nMechanical Lead 2021-22"],
    gradYear: "Class of 2024",
    years: ["2021 - 2022"],
    major: "Mechanical & Aerospace Engineering",
    image: dsingh,
  },
  {
    name: "Kevin Phan",
    roles: [
      "Golf Cart\nSoftware Lead 2023-24",
      "Pacbot\nHigh-Level lead 2022-23",
    ],
    years: ["2023 - 2024"],
    gradYear: "Class of 2024",
    major: "Computer Science",
    image: Kphan,
  },
  {
    name: "Dak Cheng",
    roles: ["Golf Cart\n Hardware Lead 2024-25"],
    years: ["2024 - 2025"],
    gradYear: "Class of 2025",
    major: "Electrical & Computer Engineering",
    image: Dc2326,
  },
  {
    name: "Alecia Barbieri",
    roles: [
      "Droid\nElectrical & Integration Lead\n2022-25",
      "WALL-E\nElectrical Lead 2024-25",
    ],
    years: ["2022 - 2023", "2023 - 2024", "2024 - 2025"],
    gradYear: "Class of 2025",
    major: "Electrical & Computer Engineering",
    image: Ab0824,
  },
  {
    name: "Freddy Hernandez",
    roles: ["WALL-E\nElectrical Lead 2024-25"],
    years: ["2024 - 2025"],
    gradYear: "Class of 2025",
    major: "Electrical & Computer Engineering",
    image: Fh9696,
  },
  {
    name: "Jimmy Tran",
    roles: ["Drone\nTeam Lead 2022-24"],
    years: ["2022 - 2023", "2023 - 2024"],
    gradYear: "Class of 2025",
    major: "Mechanical & Aerospace Engineering",
    image: Jt7347,
  },
  {
    name: "Arti Schmidt",
    roles: ["Drone\nSoftware Lead 2023-24"],
    years: ["2023 - 2024"],
    gradYear: "Class of 2024",
    major: "Computer Science",
    image: Arthurts,
  },
  {
    name: "David Chang",
    roles: [
      "Droid\nMechanical Lead 2022-23\nSoftware Lead 2023-24",
      "Drone\nMechanical Lead 2024-25",
    ],
    years: ["2022 - 2023", "2023 - 2024", "2024 - 2025"],
    gradYear: "Class of 2025",
    major: "Electrical & Computer Engineering",
    image: Dc4266,
  },
  {
    name: "Eric Chen",
    roles: ["Droid\nHardware Lead 2024-25"],
    years: ["2024 - 2025"],
    gradYear: "Class of 2025",
    major: "Electrical & Computer Engineering",
    image: Edchen,
  },
  {
    name: "Samuel Gerhard",
    roles: ["Tinker\nElectrical Lead 2024-25"],
    years: ["2024 - 2025"],
    gradYear: "Class of 2025",
    major: "Electrical & Computer Engineering",
    image: sg6836,
  },

  {
    name: "David Fu",
    roles: ["Rover\nTeam Lead 2023-24"],
    years: ["2023 - 2024"],
    gradYear: "Class of 2025",
    major: "Mechanical & Aerospace Engineering",
    image: Df1314,
  },
  {
    name: "Mariko Storey",
    roles: ["Rover\nTeam Lead 2023-24"],
    years: ["2023 - 2024"],
    gradYear: "Class of 2025",
    major: "Mechanical & Aerospace Engineering",
    image: Ms8364,
  },
  {
    name: "William Huang",
    roles: ["Rover\nTeam Lead 2023-24"],
    years: ["2023 - 2024"],
    gradYear: "Class of 2025",
    major: "Computer Science",
    image: Wh9128,
  },
  {
    name: "Divija Durga",
    roles: ["Exo\nHardware Lead 2023-24"],
    years: ["2023 - 2024"],
    gradYear: "Class of 2027",
    major: "Electrical & Computer Engineering",
    image: Dd6849,
  },
];
